// extracted by mini-css-extract-plugin
module.exports = {"input":"FormText_input__XPCQO","smallRect":"FormText_smallRect__qXYgC","outlined":"FormText_outlined__EMED2"};